import React from 'react';
import { styled, css } from 'styled-components';

import type { FieldSubscription } from '@/js/libs/final-form';

import useErrorSubscription from './useErrorSubscription.ts';

export const Wrapper = styled.span<{ $inField?: boolean }>`
  display: inline-block;
  margin-top: 4px;
  color: ${({ theme }) => theme.colors.critical100};
  ${({ $inField }) =>
    $inField &&
    css`
      position: absolute;
      bottom: 0;
      left: 15px;
      font-size: 10px;
    `}
`;

export interface ErrorProps<Name extends string> {
  name: Name;
  subscription?: FieldSubscription;
  withTouched?: boolean;
  inField?: boolean;
  children?: React.ReactNode;
  className?: string;
}

const Error: <Name extends string = string>(props: ErrorProps<Name>) => React.ReactElement = ({
  name,
  subscription,
  withTouched,
  inField = false,
  children,
  className,
}) => {
  const { hasAnyError, error, submitError } = useErrorSubscription({ name, subscription, withTouched });

  const displayError = error || submitError;
  const errorMessage = typeof displayError === 'string' ? displayError : undefined;

  return (
    <div id={`${name}-error`}>
      {errorMessage && hasAnyError ? (
        <Wrapper className={className} $inField={inField}>
          {errorMessage}
        </Wrapper>
      ) : (
        children && (
          <Wrapper className={className} $inField={inField}>
            {children}
          </Wrapper>
        )
      )}
    </div>
  );
};

export default React.memo(Error) as typeof Error;
